import React, { useEffect, useState } from "react";
import "./profile.css";
import { useDispatch, useSelector } from "react-redux";
import { addUserAccessTokenAPI, chooseActiveToken, deleteAccessTokenAPI, getActiveToken, getAllAccessTokenAPI, getAllTokens, getId, getToken, getTokenName, getTokenNameAPI, getTokenNameStatus } from "../../RTK/Slice/Auth/AuthSlice";
import { getUserByIdAPI } from "../../RTK/Slice/Admin/AdminSlice";
import imgUser from "../../Images/user2.png";
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCircleNotch, faPlus, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Backdrop, Fade, Modal } from "@mui/material";
import { notEmpty } from "../../Validation";
import { toast } from "react-toastify";
import { STATUS } from "../../Constants";

const ProfilePage = () => {

  // For Tranaslate Page 
  // const {t} = useTranslation() ; 

  // For Show Access Token List 
  const [showList , setShowList] = useState(false) ; 

  // For Access Token Name
  // const [tokenName , setTokenName] = useState('') ; 

  // For Access Add Token Field (value)
  const [tokenField , setTokenField] = useState("") ;

  // For Control Reply Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true); setShowList(false) };
  const handleClose = () => {setOpen(false) ; setShowList(false)};


  // For Dispatch Action
  const dispatch = useDispatch();

  // For Modal Style
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    p: 4,
    };
  
  // For Access Token
  const token = useSelector(getToken);

  // For Get Profile Data
  const userProfile = useSelector((state) => state.AdminSlice.userProfile);

  // For Get User ID
  const id = useSelector(getId);

  // For Rest Toke Field
  const restField = ()=>{
    setTokenField('') ; 
  }

  // For Add Token Handler
  const addTokenHandler = (e)=>{
    e.preventDefault() ; 
    if(notEmpty(tokenField) ){
      dispatch(addUserAccessTokenAPI({token , userToken :tokenField   }));
      restField() ; 
      handleClose() ;
    }else{
      toast.info("Please Enter The token") ; 
    }
      
  }

    // For Render Add Token Modal
    const renderAddTokenModal = ()=>{
      return (
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
              backdrop: {
              timeout: 300,
              },
          }}
          >
          <Fade in={open}>
              <form onSubmit={addTokenHandler} className='k-modal my-font' style={style}>

                  <div className='head'>
                      <div className='left'>
                          <h3>Add Token</h3>
                          <p>Please be carefull when you use the token and try to change between them</p>
                      </div>
                      <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                  </div>
                  <div className='body'>
                    <div className="row">
                      {/*<label htmlFor="user">Token Name</label>
                      <input className="input-row" placeholder="Enter Token Name" value={tokenName} onChange={(e)=>setTokenName(e.target.value)} />*/}
                    </div>
                    <div className="row">
                      <label htmlFor="user">Token </label>
                      <input className="input-row" placeholder="Enter Token" value={tokenField} onChange={(e)=>setTokenField(e.target.value)} />
                    </div>
                  </div>

                  <div className='btn'>
                      <button className="add-token-btn" type="submit">Add</button>
                  </div>

              </form>
              
          </Fade>
      </Modal>
      )
  }
  
  // For Delete Access Token Handler
  const deleteAccessToken = (userAccessToken)=>{
    dispatch(deleteAccessTokenAPI({token ,userAccessToken }))
  }

  // For Get Active Token 
  const activeToken = useSelector(getActiveToken) ; 

  // For Get Data When Page Loaded
  useEffect(() => {
    if (token) {
      // For Call Get All Token API
      dispatch(getAllAccessTokenAPI({token , id})) ; 

      if(notEmpty(activeToken))
        dispatch(getTokenNameAPI({userToken : activeToken , token }))

      // For Call Get User Data API
      dispatch(getUserByIdAPI({ token, id }));
    }
  }, [dispatch, token, id , activeToken]);


  // For Choose Active Token
  const chooseActiveTokenHandler = (accToken)=>{
    dispatch(chooseActiveToken(accToken)) ;
    // dispatch(getTokenNameAPI({userToken : accToken , token }))
    setShowList(false)
  }

  // For Access All Tokens
  const allTokens = useSelector(getAllTokens) ;

  // For Get Token Name 
  const tokenName = useSelector(getTokenName) ; 

  const getTokenNameStatusLoad = useSelector(getTokenNameStatus) ; 



  return (
    <div className="profile-container">
      {renderAddTokenModal()}
      {userProfile ? (
        <>
          <img
            src={imgUser}
            alt="Profile"
          />
          <h1>{/*userProfile.user.username*/} {tokenName ? tokenName :getTokenNameStatusLoad=== STATUS.LOADDING ?<FontAwesomeIcon style={{color : "gray" , fontSize : "15px"}} icon={faCircleNotch } spin /> :"No Name"} </h1>
          <div className="acc-menu ">
              <p className="acc-tkn">Access Token : {activeToken  ? ` ${activeToken?.slice(0 ,25)}...` : "Choose Token"}  </p>
              <button onClick={()=>setShowList(!showList)} ><FontAwesomeIcon icon={faChevronDown} /></button>
              <div className={ `acc-dropdown ${showList ?"active-drop" : "" } `}>
                {
                  allTokens ? 
                    allTokens?.map((item ,  idx)=>{
                      return (
                        <div key={idx} className={`tab ${item === activeToken ? 'active' : ''}`}>
                          <p  className="" onClick={()=>chooseActiveTokenHandler(item)}>{item?.length > 28 ? `${item?.slice(0,28)}...` : item}</p>
                          <div className="del-btn" onClick={()=>deleteAccessToken(item)}><FontAwesomeIcon icon={faTrash} /></div>
                        </div>
                      )
                    })
                  :
                  ""
                }

                <div className="tab">
                  <p className="" onClick={handleOpen}>Add Token <FontAwesomeIcon icon={faPlus} /></p>
                </div>
              </div>
          </div>

          <div className="info-section">
            <h2>About</h2>
            <p>Status: {userProfile.user.status}</p>
            <p>Email: {userProfile.user.email}</p>
            {/*<p>Role: {userProfile.user.role}</p>*/}
            <p>points: {userProfile.user.points}</p>
            <p>Joined: {new Date(userProfile.user.createdAt).toLocaleDateString()}</p>
          </div>
        </>
      ) : (
        <p>Loading profile...</p>
      )}

      <Tooltip id="my-tooltip" />
    </div>
  );
};

export default ProfilePage;